export default __webpack_public_path__ + "static/media/GoodMannersOnThePlayground_02.c5d95905.png";